/**
 * @param {*} initialState
 * @param {Object} reducers
 * @param {Boolean} [mutating]
 */
export const createReducer = (initialState, reducers, mutating = true) => (
    (state = initialState, action) => {
        const {type, payload} = action;

        if (Object.hasOwnProperty.call(reducers, type)) {
            const diff = reducers[type](state, payload, action);

            if (state === diff) return state;

            if (mutating) {
                return {
                    ...state,
                    ...diff,
                };
            }

            return diff;
        }

        return state;
    }
);



// WEBPACK FOOTER //
// ./scripts/utils/reducer.js